import { Box, Text, Flex, Button } from '@chakra-ui/react';
import React from 'react';
import { Link } from 'react-router-dom';
import Collapsible from 'react-collapsible';
import { FaCaretDown, FaCaretRight } from 'react-icons/fa';
import { FiPlus } from 'react-icons/fi';

export default function StudentPrograms({ programTypes, studentId, onAddProgram }) {
  if (!programTypes || programTypes.length === 0) {
    return (
      <Box
        bg="white"
        borderRadius="xl"
        border="1px solid"
        borderColor="gray.200"
        p={5}
      >
        <Flex justify="space-between" align="center" mb={2}>
          <Text fontWeight="600">Programas</Text>
          {onAddProgram && (
            <Button
              leftIcon={<FiPlus />}
              size="sm"
              bg="#574feb"
              colorScheme="purple"
              onClick={onAddProgram}
            >
              Agregar programa
            </Button>
          )}
        </Flex>
        <Text color="gray.500" fontSize="sm">
          Este estudiante no tiene programas matriculados
        </Text>
      </Box>
    );
  }

  return (
    <Box
      bg="white"
      borderRadius="xl"
      border="1px solid"
      borderColor="gray.200"
      p={5}
    >
      <Flex justify="space-between" align="center" mb={3}>
        <Text fontWeight="600">Programas</Text>
        {onAddProgram && (
          <Button
            leftIcon={<FiPlus />}
            size="sm"
            bg="#574feb"
            colorScheme="purple"
            onClick={onAddProgram}
          >
            Agregar programa
          </Button>
        )}
      </Flex>
      <Box maxH="320px" overflowY="auto">
        {programTypes.map((programType) => {
          const unique = programType.programs.filter(
            (el, index, self) => self.findIndex((v) => v.id === el.id) === index
          );

          return (
            <Box key={programType.id} mb={2}>
              <Collapsible
                trigger={
                  <Flex
                    cursor="pointer"
                    bg="white"
                    border="1px solid"
                    borderColor="blue.400"
                    p="10px"
                    borderRadius="lg"
                    align="center"
                    _hover={{ bg: 'gray.50' }}
                  >
                    <Text fontSize="sm" fontWeight="500">{programType.name}</Text>
                    <Box ml={2}><FaCaretDown color="#3272F1" /></Box>
                  </Flex>
                }
              >
                {unique.map((program) => (
                  <Box key={program.id} ml={6} mt={2}>
                    <Collapsible
                      trigger={
                        <Flex
                          bg="white"
                          border="1px solid"
                          borderColor="blue.400"
                          borderRadius="lg"
                          p="10px"
                          align="center"
                          cursor="pointer"
                          _hover={{ bg: 'gray.50' }}
                        >
                          <Text fontSize="sm">{program.name}</Text>
                          <Box ml={2}><FaCaretDown size="12px" /></Box>
                        </Flex>
                      }
                    >
                      <Box pl={6} mt={1}>
                        <Link
                          to={`/plataforma/school/ver-resultados/${programType.slug}/${program.slug}?id=${studentId}`}
                        >
                          <Flex
                            border="1px solid"
                            borderColor="blue.400"
                            borderRadius="lg"
                            px={3}
                            py={2}
                            align="center"
                            cursor="pointer"
                            fontSize="sm"
                            _hover={{ bg: 'blue.50' }}
                          >
                            Notas
                            <Box ml={2}><FaCaretRight size="10px" /></Box>
                          </Flex>
                        </Link>
                      </Box>
                    </Collapsible>
                  </Box>
                ))}
              </Collapsible>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}
